import React from 'react'

import {STOPPAGE_TYPE_TRANSLATION_KEYS} from '../../consts'
import {FormStoppageType, StoppageType} from '../../types'

import {CommonDropDown, CommonProps} from './SharedDropDowns'

type StoppageTypeItem = {
  type: StoppageType
  description: string
  hidden?: boolean
}

export const EventStoppageTypeDropDown: React.FC<CommonProps<StoppageType>> = (props) => {
  const {translate} = props
  const stoppageTypes: StoppageTypeItem[] = [
    {
      type: FormStoppageType.Kiln,
      description: translate(STOPPAGE_TYPE_TRANSLATION_KEYS[FormStoppageType.Kiln])
    },
    {
      type: FormStoppageType.CementMill,
      description: translate(STOPPAGE_TYPE_TRANSLATION_KEYS[FormStoppageType.CementMill])
    },
    {
      type: FormStoppageType.RawMill,
      description: translate(STOPPAGE_TYPE_TRANSLATION_KEYS[FormStoppageType.RawMill])
    },
    {
      type: FormStoppageType.CoalMill,
      description: translate(STOPPAGE_TYPE_TRANSLATION_KEYS[FormStoppageType.CoalMill])
    },
    {
      type: FormStoppageType.Crusher,
      description: translate(STOPPAGE_TYPE_TRANSLATION_KEYS[FormStoppageType.Crusher])
    },
    {
      type: FormStoppageType.AlternativeFuelInstallation,
      description: translate(
        STOPPAGE_TYPE_TRANSLATION_KEYS[FormStoppageType.AlternativeFuelInstallation]
      )
    },
    {
      type: FormStoppageType.Bypass,
      description: translate(STOPPAGE_TYPE_TRANSLATION_KEYS[FormStoppageType.Bypass])
    },
    {
      type: FormStoppageType.Other,
      description: translate(STOPPAGE_TYPE_TRANSLATION_KEYS[FormStoppageType.Other])
    }
  ]

  return (
    <CommonDropDown
      {...props}
      keyName="stoppageType"
      options={stoppageTypes.map((st) => st.type)}
      customTemplate={(type) => {
        const {description} = stoppageTypes.find((st) => st.type === type) ?? {description: ''}
        return description
      }}
    />
  )
}
